export enum EditSensorEvent {
  change = 'change',
  isFormValid = 'isFormValid',
}
